/**
 * Client mirror of server/weather/utils/ideamProductCopyUtils.js for offline UI and tests.
 * Prefer API `ui` fields from GET /colombia/radar/preferred when available.
 */

export const IDEAM_ATTRIBUTION_TEXT = "Data © IDEAM";
export const RAINVIEWER_ATTRIBUTION_TEXT = "Radar data © RainViewer";
export const RAINVIEWER_SOURCE_LABEL = "RainViewer Colombia Fallback";
export const RAINVIEWER_FALLBACK_WARNING =
  "Showing RainViewer backup because the official IDEAM layer is unavailable or stale.";

export function getProductCopyProfile(productIdentityStatus = "unknown_product_identity") {
  switch (productIdentityStatus) {
    case "confirmed_radar_composite":
      return {
        productIdentityStatus,
        sourceLabel: "IDEAM Official Radar Composite",
        sourceLongLabel: "IDEAM Imagen Compuesta de Radares Meteorológicos",
        sourceDescription: "Official IDEAM radar composite layer for Colombia.",
        layerControlLabel: "IDEAM Official Radar Composite",
        layerControlDescription:
          "Official IDEAM radar composite layer for Colombia (experimental while validation continues).",
        experimentalMessage:
          "IDEAM radar composite source is official but remains experimental while validation continues.",
        attribution: IDEAM_ATTRIBUTION_TEXT,
        staleWarning: "Official IDEAM radar composite may be stale.",
        downWarning: "Official IDEAM radar composite is unavailable.",
        unknownFreshnessWarning: "IDEAM radar composite freshness could not be confirmed.",
      };
    case "official_precipitation_intensity":
      return {
        productIdentityStatus,
        sourceLabel: "IDEAM Official Precipitation Intensity",
        sourceLongLabel: "IDEAM OSPA / Official Precipitation Intensity",
        sourceDescription: "Official IDEAM precipitation intensity layer for Colombia.",
        layerControlLabel: "IDEAM Official Precipitation Intensity",
        layerControlDescription:
          "Official IDEAM precipitation intensity layer for Colombia (experimental while validation continues).",
        experimentalMessage:
          "IDEAM precipitation intensity source is official but remains experimental while validation continues.",
        attribution: IDEAM_ATTRIBUTION_TEXT,
        staleWarning: "Official IDEAM precipitation intensity may be stale.",
        downWarning: "Official IDEAM precipitation intensity is unavailable.",
        unknownFreshnessWarning: "IDEAM precipitation intensity freshness could not be confirmed.",
      };
    default:
      return {
        productIdentityStatus: "unknown_product_identity",
        sourceLabel: "IDEAM Official Weather Layer",
        sourceLongLabel: "IDEAM Weather Layer — Product Identity Under Validation",
        sourceDescription: "Official IDEAM weather layer. Product identity is still under validation.",
        layerControlLabel: "IDEAM Official Weather Layer",
        layerControlDescription:
          "Official IDEAM weather layer; product identity is still under validation (experimental).",
        experimentalMessage:
          "IDEAM source is official-looking but the exact product identity is still under validation.",
        attribution: IDEAM_ATTRIBUTION_TEXT,
        staleWarning: "Official IDEAM weather layer may be stale.",
        downWarning: "Official IDEAM weather layer is unavailable.",
        unknownFreshnessWarning: "IDEAM weather layer freshness could not be confirmed.",
      };
  }
}

/** Default production overlay candidate identity (OSPA MapServer). */
export const DEFAULT_IDEAM_PRODUCT_IDENTITY = "official_precipitation_intensity";

export function getDefaultIdeamCopyProfile() {
  return getProductCopyProfile(DEFAULT_IDEAM_PRODUCT_IDENTITY);
}
